<template lang="pug">
    v-card.mb-5
        v-container.py-5
            v-row
                v-container(justify ='center')
                    v-card-title
                        h3 Ordenes de compra
                        generar_orden_compra_directamente
            v-data-table( v-model="Datos.registro" :headers='headers' :items='Registro_compras' item-key='key' :footer-props="footerProps" sort-desc sort-by='numero_de_operacion')
                template(v-slot:item.action='{item}')
                    v-row
                        orden_de_compra_imprimir( :llave= 'item.key' )
                        v-spacer
                        agregar_comprobante_de_pago( :llave='item.key' :estado='item.estado_del_documento == "comprobante generado" || item.estado_del_documento == "procesando"')
                    
</template>
<script>
import {db} from '@/FirebaseConfig'
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
    data: () => ({
      headers: [
      { text: 'Nº',  value: 'numero_de_operacion' },
      { text: 'Creado por', value:'creado_por' },
      { text: 'Frecha de creación', value:'creado_el' },
      { text: 'Acciones', value: 'action'}
      ],
      footerProps: {
        'items-per-page-options':   [15, 30, 50]
      },
    }),
    methods:{
 
        ver_propuestas (idCotizacion) {
            this.encabezados_con_proveedor = [...this.headers]
            this.Proveedores.map(item => this.encabezados_con_proveedor.push({text: item, value: item}))
            this.$store.dispatch('Cotizaciones/ver_propuestas', idCotizacion)
        },
    },
    computed:{
        ...mapGetters({
            Registro_compras: 'Ordenes_de_compra/registro',
        }),
         ...mapState({
            Datos: state=> state.Ordenes_de_compra.datos,
            Ordenes_de_compra : state =>state.Ordenes_de_compra
        })
    },
    components:{
        orden_de_compra_imprimir: ()=>import('.././componentes/orden_de_compra_imprimir'),
        agregar_comprobante_de_pago: ()=> import('.././componentes/agregar_comprobante_de_pago'),
        generar_orden_compra_directamente:()=> import('.././componentes/generar_orden_compra_directamente')
    }
}
</script>
